<template>
  <v-container fluid class="pa-0">
    <v-app-bar app dark>
      <v-toolbar-title>Mail</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="syncEmails">
        <v-icon>mdi-sync</v-icon>
      </v-btn>
    </v-app-bar>

    <v-row no-gutters>
      <v-col :md="isMobile ? 12 : 4" class="mailbox">
        <ComposeButton />
        <FolderList />
        <Mailbox />
      </v-col>
      <v-col :md="isMobile ? 12 : 8" class="email-view" v-if="!isMobile">
        <EmailView />
      </v-col>
      <v-dialog
        :value="!!selectedEmail"
        @input="!$event && $store.dispatch('mailStore/selectEmail', null)"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition">
        <v-card dark> <EmailView /></v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import Mailbox from "./components/Mailbox.vue"
import EmailView from "./components/EmailView.vue"
import ComposeButton from "./components/ComposeButton.vue"
import FolderList from "./components/FolderList.vue"
import api from "@/api"

export default {
  name: "Mail",
  components: {
    Mailbox,
    EmailView,
    ComposeButton,
    FolderList,
  },
  computed: {
    ...mapGetters("mailStore", ["selectedEmail"]),
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
  },
  created() {
    this.$store.dispatch("mailStore/fetchEmails")
    this.$store.dispatch("mailStore/fetchFolders")
    this.$store.dispatch("mailStore/fetchCategories")
    this.$store.dispatch("mailStore/fetchStudios")
  },
  methods: {
    syncEmails() {
      this.$store.dispatch("mailStore/syncEmails")
    },
  },
}
</script>

<style lang="scss" scoped>
.mailbox {
  background-color: #212121;
  padding: 16px;
}

.email-view {
  background-color: #1a1a1a;
}
</style>
